module.exports = __webpack_public_path__ + "static/media/ice11.abb41737.webp";